<script>
  import { cart } from "$lib/state/cart";
  import { cartTotals } from "$lib/state/cartTotals";
  import { goto } from "$app/navigation";
  //**COMPONENTS**//
  import ShoppingCartRow from "$lib/components/cart/ShoppingCartRow.svelte";

  /** @typedef {import('$lib/types').MagentoCart} MagentoCart */
  /** @typedef {import('$lib/types').MagentoCartTotals} MagentoCartTotals */

  /** @type {HTMLDivElement} */
  let cartModalElement;
  /** @type {?MagentoCart} */
  let shoppingCart = null;
  /** @type {?MagentoCartTotals} */
  let shoppingCartTotals = null;

  cart.subscribe((value) => {
    shoppingCart = value;
  });

  cartTotals.subscribe((value) => (shoppingCartTotals = value));

  let openedCartModal = false;
  /** @param {*} event*/
  function handleCartModalEscape(event) {
    if (event.code === "Escape") {
      toggleCartModal();
    }
  }

  function handleClickOnBody() {
    toggleCartModal();
  }

  /**@param {*} event */
  function stopEventPropagation(event) {
    event.stopPropagation();
  }

  function toggleCartModal() {
    if (openedCartModal) {
      document.removeEventListener("keyup", handleCartModalEscape);
      document.removeEventListener("click", handleClickOnBody);
      cartModalElement.removeEventListener("click", stopEventPropagation);
    } else {
      document.addEventListener("keyup", handleCartModalEscape);
      document.addEventListener("click", handleClickOnBody, { once: true });
      cartModalElement.addEventListener("click", stopEventPropagation);
    }

    openedCartModal = !openedCartModal;
  }
</script>

<div class="wrapper" bind:this={cartModalElement}>
  <button
    class="cart-button-icon shoppingCartButton desktop-cart"
    type="button"
    on:click={toggleCartModal}
    aria-label="Open Shopping cart modal"
    aria-labelledby="iconCartButton"
  >
    {#if shoppingCart !== null && shoppingCart?.items_qty > 0}
      <img loading="eager" src="/images/svg/shoppingbag.svg" alt="shopping bag" />
      <span>{shoppingCart.items_qty}</span>
    {:else}
      <img loading="eager" src="/images/svg/shoppingbag.svg" alt="shopping bag" />
    {/if}
  </button>
  <a href="/cart" class="cart-button-icon shoppingCartButton mobile-cart">
    {#if shoppingCart !== null && shoppingCart?.items_qty > 0}
      <img loading="eager" src="/images/svg/shoppingbag.svg" alt="shopping bag" />
      <span>{shoppingCart.items_qty}</span>
    {:else}
      <img loading="eager" src="/images/svg/shoppingbag.svg" alt="shopping bag" />
    {/if}
  </a>
  {#if openedCartModal}
    <div class="small-cart">
      <div class="cart-list">
        {#each shoppingCart?.items ?? [] as item}
          <ShoppingCartRow cartItem={item} size="small" />
        {:else}
          <p class="empty-cart">Your shopping bag is empty</p>
        {/each}
      </div>
      <div class="cart-totals">
        <p class="sub-total">Sub Total:</p>
        <p class="sub-total">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(shoppingCartTotals?.base_subtotal ?? 0)}
        </p>
      </div>

      {#if Math.abs(shoppingCartTotals?.discount_amount ?? 0) > 0}
        <div class="cart-totals">
          <p class="sub-total">Discount:</p>
          <p class="sub-total">
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(shoppingCartTotals?.discount_amount ?? 0)}
          </p>
        </div>
      {/if}
      <p style="text-align: center; font-size: 0.875rem; font-family: 'gotham-book'; ">Discount coupons are not combined <br /> with any other promotions.</p>
      <button
        class="cart-button"
        on:click={() => {
          goto("/cart");
          toggleCartModal();
        }}
      >
        Shopping bag
      </button>
    </div>
  {/if}
</div>

<style>
  .wrapper {
    position: relative;
  }
  .cart-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: calc(200px * 2);
    padding-right: 16px;
  }
  .cart-button {
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    width: 90%;
    text-decoration: none;
    font-size: 1rem;
    border: 1px solid #1e2525;
    text-align: center;
    padding: 10px 0;
    border-radius: 24px;
    transition: all 0.5s ease;
    text-align: center;
  }
  .cart-button:hover {
    color: #fdfdfd;
    background-color: #1e2525;
  }

  .small-cart {
    position: absolute;
    background: white;
    padding: 30px 24px 43px;
    flex-direction: column;
    align-items: center;
    max-width: 440px;
    width: 95svw;
    display: flex;
    gap: 16px;
    right: 0;
    top: calc(var(--header-height) - 20px);
    box-shadow: 0px 3px 6px rgba(124, 115, 115, 0.75);
    z-index: 50;
    border-radius: 20px 0 20px 20px;
  }
  .empty-cart {
    font-size: 1em;
    font-weight: 500;
    color: #6c6c6c;
    padding: 0;
    overflow: hidden;
  }
  .cart-totals {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 0 14px 0;
  }
  .cart-totals:nth-child(2) {
    border-top: 1px solid #000;
    margin-top: 14px;
    padding-top: 14px;
  }
  .cart-totals .sub-total {
    font-weight: 500;
    font-size: 0.875em;
  }
  .cart-button-icon {
    width: 25px;
    height: 25px;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
  .cart-button-icon span {
    position: absolute;
    top: -8px;
    right: -12px;
    font-size: 0.725rem;
    font-weight: 500;
    font-family: "gotham-medium";
    color: #fff;
    background-color: #d8364c;
    border: 1px solid #d8364c;
    border-radius: 50%;
    width: 18px;
    aspect-ratio: 1/1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mobile-cart {
    display: none;
  }

  @media (max-width: 768px) {
    .cart-button-icon {
      width: 24px;
      height: 24px;
      margin-top: 3px;
    }
  }

  @media (max-width: 767px) {
    .desktop-cart {
      display: none;
    }
    .mobile-cart {
      display: block;
    }
  }
</style>
